(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-carousel"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('carouselContainer');
  const track = document.getElementById('carouselTrack');
  const prevBtn = document.getElementById('carouselPrev');
  const nextBtn = document.getElementById('carouselNext');

  if (!track || !container || !prevBtn || !nextBtn) return;

  let currentIndex = 0;
  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let isDragging = false;
  let startTranslate = 0;
  let startTime = 0;
  let axisLocked = null;

  function getIsMobile() {
    return window.innerWidth < 990;
  }

  function getSlideWidth() {
    const slide = track.querySelector('.custom-collection-carousel__slide');
    if (!slide) return 0;
    return slide.offsetWidth;
  }

  function getGap() {
    return 2;
  }

  function getMaxIndex() {
    const totalSlides = track.children.length;
    const isMobile = getIsMobile();

    if (isMobile) {
      return totalSlides - 1;
    } else {
      return Math.max(0, totalSlides - 3);
    }
  }

  function updateCarousel(smooth = true) {
    const slideWidth = getSlideWidth();
    const gap = getGap();
    const offset = currentIndex * (slideWidth + gap);

    track.style.transition = smooth
      ? 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      : 'none';

    track.style.transform = `translateX(-${offset}px)`;
  }

  function constrainIndex() {
    const maxIndex = getMaxIndex();
    if (currentIndex < 0) currentIndex = 0;
    if (currentIndex > maxIndex) currentIndex = maxIndex;
  }

  function handlePrev() {
    if (isDragging) return;
    currentIndex--;
    constrainIndex();
    updateCarousel(true);
  }

  function handleNext() {
    if (isDragging) return;
    currentIndex++;
    constrainIndex();
    updateCarousel(true);
  }

  // Desktop mouse drag (unchanged)
  function handleMouseDown(e) {
    if (!getIsMobile()) return;

    isDragging = true;
    startX = e.clientX;
    startTime = Date.now();
    currentX = 0;

    const slideWidth = getSlideWidth();
    const gap = getGap();
    startTranslate = currentIndex * (slideWidth + gap);

    container.classList.add('grabbing');
    track.style.transition = 'none';
  }

  function handleMouseMove(e) {
    if (!isDragging || !getIsMobile()) return;

    currentX = e.clientX - startX;
    const newTranslate = startTranslate - currentX;
    track.style.transform = `translateX(-${newTranslate}px)`;
  }

  function handleMouseUp() {
    if (!isDragging) return;

    isDragging = false;
    container.classList.remove('grabbing');

    const slideWidth = getSlideWidth();
    const dragThreshold = slideWidth * 0.25;
    const elapsed = Date.now() - startTime;
    const velocity = Math.abs(currentX) / elapsed;

    if (Math.abs(currentX) > dragThreshold || velocity > 0.5) {
      currentIndex += currentX > 0 ? -1 : 1;
    }

    constrainIndex();
    updateCarousel(true);
  }

  // Mobile touch swipe, locked to horizontal axis only
  function handleTouchStart(e) {
    if (!getIsMobile()) return;

    isDragging = true;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    startTime = Date.now();
    currentX = 0;
    axisLocked = null;

    const slideWidth = getSlideWidth();
    const gap = getGap();
    startTranslate = currentIndex * (slideWidth + gap);

    track.style.transition = 'none';
  }

  function handleTouchMove(e) {
    if (!isDragging || !getIsMobile()) return;

    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;
    const deltaX = touchX - startX;
    const deltaY = touchY - startY;

    if (!axisLocked) {
      if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
      axisLocked = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
    }

    if (axisLocked === 'y') return;

    e.preventDefault();
    currentX = deltaX;
    const newTranslate = startTranslate - currentX;
    track.style.transform = `translateX(-${newTranslate}px)`;
  }

  function handleTouchEnd() {
    if (!isDragging) return;

    isDragging = false;

    if (axisLocked === 'x') {
      const slideWidth = getSlideWidth();
      const dragThreshold = slideWidth * 0.25;
      const elapsed = Date.now() - startTime;
      const velocity = Math.abs(currentX) / elapsed;

      if (Math.abs(currentX) > dragThreshold || velocity > 0.5) {
        currentIndex += currentX > 0 ? -1 : 1;
      }
    }

    constrainIndex();
    updateCarousel(true);
    axisLocked = null;
  }

  prevBtn.addEventListener('click', handlePrev);
  nextBtn.addEventListener('click', handleNext);

  container.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);

  container.addEventListener('touchstart', handleTouchStart, { passive: true });
  container.addEventListener('touchmove', handleTouchMove, { passive: false });
  container.addEventListener('touchend', handleTouchEnd, { passive: true });

  window.addEventListener('resize', () => {
    constrainIndex();
    updateCarousel(false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('productContainer');
  const track = document.getElementById('productTrack');
  const prevBtn = document.getElementById('productPrev');
  const nextBtn = document.getElementById('productNext');

  if (!track || !container || !prevBtn || !nextBtn) return;

  let currentIndex = 0;
  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let isDragging = false;
  let startTranslate = 0;
  let axisLocked = null;

  function getIsMobile() {
    return window.innerWidth < 990;
  }

  function getSlideWidth() {
    const slide = track.querySelector('.custom-product-list__slide');
    if (!slide) return 0;
    return slide.offsetWidth;
  }

  function getGap() {
    return 2;
  }

  function getMaxIndex() {
    const totalSlides = track.children.length;
    const isMobile = getIsMobile();

    if (isMobile) {
      return totalSlides - 1;
    } else {
      return Math.max(0, totalSlides - 4);
    }
  }

  function updateCarousel(smooth = true) {
    const slideWidth = getSlideWidth();
    const gap = getGap();
    const offset = currentIndex * (slideWidth + gap);

    track.style.transition = smooth
      ? 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      : 'none';

    track.style.transform = `translateX(-${offset}px)`;
  }

  function constrainIndex() {
    const maxIndex = getMaxIndex();
    if (currentIndex < 0) currentIndex = 0;
    if (currentIndex > maxIndex) currentIndex = maxIndex;
  }

  function handlePrev() {
    if (isDragging) return;
    currentIndex--;
    constrainIndex();
    updateCarousel(true);
  }

  function handleNext() {
    if (isDragging) return;
    currentIndex++;
    constrainIndex();
    updateCarousel(true);
  }

  // Desktop mouse drag (unchanged)
  function handleMouseDown(e) {
    if (!getIsMobile()) return;

    isDragging = true;
    startX = e.clientX;
    currentX = 0;

    const slideWidth = getSlideWidth();
    const gap = getGap();
    startTranslate = currentIndex * (slideWidth + gap);

    container.classList.add('grabbing');
    track.style.transition = 'none';
  }

  function handleMouseMove(e) {
    if (!isDragging || !getIsMobile()) return;

    currentX = e.clientX - startX;
    const newTranslate = startTranslate - currentX;
    track.style.transform = `translateX(-${newTranslate}px)`;
  }

  function handleMouseUp() {
    if (!isDragging) return;

    isDragging = false;
    container.classList.remove('grabbing');

    const slideWidth = getSlideWidth();
    const dragThreshold = slideWidth * 0.15;

    if (Math.abs(currentX) > dragThreshold) {
      currentIndex += currentX > 0 ? -1 : 1;
    }

    constrainIndex();
    updateCarousel(true);
  }

  // Mobile touch swipe, locked to horizontal axis only
  function handleTouchStart(e) {
    if (!getIsMobile()) return;

    isDragging = true;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    currentX = 0;
    axisLocked = null;

    const slideWidth = getSlideWidth();
    const gap = getGap();
    startTranslate = currentIndex * (slideWidth + gap);

    track.style.transition = 'none';
  }

  function handleTouchMove(e) {
    if (!isDragging || !getIsMobile()) return;

    const touchX = e.touches[0].clientX;
    const touchY = e.touches[0].clientY;
    const deltaX = touchX - startX;
    const deltaY = touchY - startY;

    if (!axisLocked) {
      if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
      axisLocked = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
    }

    if (axisLocked === 'y') return;

    e.preventDefault();
    currentX = deltaX;
    const newTranslate = startTranslate - currentX;
    track.style.transform = `translateX(-${newTranslate}px)`;
  }

  function handleTouchEnd() {
    if (!isDragging) return;

    isDragging = false;

    if (axisLocked === 'x') {
      const slideWidth = getSlideWidth();
      const dragThreshold = slideWidth * 0.15;

      if (Math.abs(currentX) > dragThreshold) {
        currentIndex += currentX > 0 ? -1 : 1;
      }
    }

    constrainIndex();
    updateCarousel(true);
    axisLocked = null;
  }

  prevBtn.addEventListener('click', handlePrev);
  nextBtn.addEventListener('click', handleNext);

  container.addEventListener('mousedown', handleMouseDown);
  document.addEventListener('mousemove', handleMouseMove);
  document.addEventListener('mouseup', handleMouseUp);

  container.addEventListener('touchstart', handleTouchStart, { passive: true });
  container.addEventListener('touchmove', handleTouchMove, { passive: false });
  container.addEventListener('touchend', handleTouchEnd, { passive: true });

  window.addEventListener('resize', () => {
    constrainIndex();
    updateCarousel(false);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-related-products"] && !Shopify.designMode) return;
  try {
    
(function () {

  function initCarousel(section) {

    if (!section) return;

    const container =
      section.querySelector(
        '.custom-related-products__container'
      );

    const track =
      section.querySelector(
        '.custom-related-products__track'
      );

    const prevBtn = document.getElementById('productPrev');
    const nextBtn = document.getElementById('productNext');

    if (!container || !track) return;


    /*
     * Prevent duplicate initialization
     */

    if (
      track.dataset.carouselInitialized === 'true'
    ) {
      return;
    }

    track.dataset.carouselInitialized = 'true';


    /*
     * =========================================
     * STATE
     * =========================================
     */

    let currentIndex = 0;

    let startX = 0;
    let startY = 0;

    let currentX = 0;

    let startTranslate = 0;

    let isDragging = false;

    /*
     * null = gesture not decided yet
     * horizontal = carousel owns gesture
     * vertical = browser owns gesture
     */
    let gestureDirection = null;


    /*
     * =========================================
     * HELPERS
     * =========================================
     */

    function isMobile() {

      return window.innerWidth < 990;

    }


    function getSlideWidth() {

      const slide =
        track.querySelector(
          '.custom-related-products__slide'
        );

      return slide
        ? slide.offsetWidth
        : 0;

    }


    function getGap() {

      return 2;

    }


    function getMaxIndex() {

      const totalSlides =
        track.children.length;


      if (isMobile()) {

        return Math.max(
          0,
          totalSlides - 1
        );

      }


      return Math.max(
        0,
        totalSlides - 4
      );

    }


    function constrainIndex() {

      const maxIndex =
        getMaxIndex();


      currentIndex =
        Math.max(
          0,
          Math.min(
            currentIndex,
            maxIndex
          )
        );

    }


    function updateCarousel(smooth) {

      const slideWidth =
        getSlideWidth();


      if (!slideWidth) return;


      const offset =
        currentIndex *
        (slideWidth + getGap());


      track.style.transition =
        smooth
          ? 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
          : 'none';


      track.style.transform =
        `translate3d(-${offset}px, 0, 0)`;

    }


    /*
     * =========================================
     * ARROWS
     * =========================================
     */

    if (prevBtn) {

      prevBtn.addEventListener(
        'click',
        function () {

          if (isDragging) return;

          currentIndex--;

          constrainIndex();

          updateCarousel(true);

        }
      );

    }


    if (nextBtn) {

      nextBtn.addEventListener(
        'click',
        function () {

          if (isDragging) return;

          currentIndex++;

          constrainIndex();

          updateCarousel(true);

        }
      );

    }


    /*
     * =========================================
     * MOBILE TOUCH START
     * =========================================
     */

    function touchStart(event) {

      if (!isMobile()) return;

      if (
        !event.touches ||
        !event.touches.length
      ) {
        return;
      }


      const touch =
        event.touches[0];


      startX =
        touch.clientX;

      startY =
        touch.clientY;


      currentX = 0;


      startTranslate =
        currentIndex *
        (
          getSlideWidth() +
          getGap()
        );


      /*
       * Gesture has not been decided yet.
       */
      gestureDirection = null;

      isDragging = false;

      track.style.transition = 'none';

    }


    /*
     * =========================================
     * MOBILE TOUCH MOVE
     * =========================================
     */

    function touchMove(event) {

      if (
        !isMobile() ||
        !event.touches ||
        !event.touches.length
      ) {
        return;
      }


      const touch =
        event.touches[0];


      const deltaX =
        touch.clientX - startX;


      const deltaY =
        touch.clientY - startY;


      /*
       * =======================================
       * DECIDE GESTURE DIRECTION
       * =======================================
       *
       * Don't decide too early.
       */

      if (!gestureDirection) {

        const distanceMoved =
          Math.sqrt(
            deltaX * deltaX +
            deltaY * deltaY
          );


        /*
         * Small finger movements are ignored.
         */
        if (distanceMoved < 8) {
          return;
        }


        /*
         * Horizontal movement wins only if
         * it is clearly more horizontal.
         */
        if (
          Math.abs(deltaX) >
          Math.abs(deltaY) * 1.15
        ) {

          gestureDirection =
            'horizontal';

        } else {

          gestureDirection =
            'vertical';

          /*
           * Browser gets full control.
           */
          isDragging = false;

          return;

        }

      }


      /*
       * =======================================
       * VERTICAL GESTURE
       * =======================================
       */

      if (
        gestureDirection === 'vertical'
      ) {

        return;

      }


      /*
       * =======================================
       * HORIZONTAL GESTURE
       * =======================================
       */

      isDragging = true;


      currentX =
        deltaX;


      /*
       * Now that we KNOW this is horizontal,
       * prevent the page from scrolling.
       */
      event.preventDefault();


      const newTranslate =
        startTranslate -
        currentX;


      track.style.transform =
        `translate3d(-${newTranslate}px, 0, 0)`;

    }


    /*
     * =========================================
     * MOBILE TOUCH END
     * =========================================
     */

    function touchEnd() {

      /*
       * Vertical gesture:
       * do absolutely nothing.
       */
      if (
        gestureDirection !==
        'horizontal'
      ) {

        gestureDirection = null;

        isDragging = false;

        return;

      }


      isDragging = false;


      const threshold =
        getSlideWidth() * 0.15;


      /*
       * Enough horizontal movement?
       */

      if (
        Math.abs(currentX) >
        threshold
      ) {

        if (currentX > 0) {

          currentIndex--;

        } else {

          currentIndex++;

        }

      }


      constrainIndex();

      updateCarousel(true);


      gestureDirection = null;

      currentX = 0;

    }


    /*
     * =========================================
     * TOUCH EVENTS
     * =========================================
     */

    container.addEventListener(
      'touchstart',
      touchStart,
      {
        passive: true
      }
    );


    /*
     * IMPORTANT:
     * passive:false is required because we
     * preventDefault ONLY after determining
     * that the gesture is horizontal.
     */

    container.addEventListener(
      'touchmove',
      touchMove,
      {
        passive: false
      }
    );


    container.addEventListener(
      'touchend',
      touchEnd,
      {
        passive: true
      }
    );


    container.addEventListener(
      'touchcancel',
      function () {

        isDragging = false;

        gestureDirection = null;

        currentX = 0;

        updateCarousel(true);

      },
      {
        passive: true
      }
    );


    /*
     * =========================================
     * MOUSE DRAG
     * =========================================
     */

    function mouseDown(event) {

      if (!isMobile()) return;

      if (event.button !== 0) return;


      isDragging = true;

      gestureDirection =
        'horizontal';


      startX =
        event.clientX;


      currentX = 0;


      startTranslate =
        currentIndex *
        (
          getSlideWidth() +
          getGap()
        );


      container.classList.add(
        'grabbing'
      );


      track.style.transition =
        'none';

    }


    function mouseMove(event) {

      if (
        !isDragging ||
        !isMobile()
      ) {
        return;
      }


      currentX =
        event.clientX -
        startX;


      const newTranslate =
        startTranslate -
        currentX;


      track.style.transform =
        `translate3d(-${newTranslate}px, 0, 0)`;

    }


    function mouseUp() {

      if (!isDragging) return;


      isDragging = false;


      container.classList.remove(
        'grabbing'
      );


      const threshold =
        getSlideWidth() * 0.15;


      if (
        Math.abs(currentX) >
        threshold
      ) {

        if (currentX > 0) {

          currentIndex--;

        } else {

          currentIndex++;

        }

      }


      constrainIndex();

      updateCarousel(true);

    }


    container.addEventListener(
      'mousedown',
      mouseDown
    );


    document.addEventListener(
      'mousemove',
      mouseMove
    );


    document.addEventListener(
      'mouseup',
      mouseUp
    );


    /*
     * =========================================
     * RESIZE
     * =========================================
     */

    window.addEventListener(
      'resize',
      function () {

        constrainIndex();

        updateCarousel(false);

      }
    );


    /*
     * =========================================
     * INITIAL
     * =========================================
     */

    updateCarousel(false);

  }


  /*
   * =========================================
   * LOAD SHOPIFY RECOMMENDATIONS
   * =========================================
   */

  function loadRecommendations(
    section,
    attempt
  ) {

    if (!section) return;


    attempt =
      attempt || 0;


    /*
     * Maximum retry attempts.
     */

    const MAX_ATTEMPTS = 4;


    /*
     * Already successfully loaded.
     */

    if (
      section.dataset.recommendationsLoaded ===
      'true'
    ) {

      return;

    }


    const url =
      section.dataset.url;


    if (!url) return;


    section.dataset.recommendationsLoaded =
      'loading';


    fetch(
      url,
      {
        credentials: 'same-origin',
        cache: 'no-store'
      }
    )

      .then(function (response) {

        if (!response.ok) {

          throw new Error(
            'Recommendation request failed: ' +
            response.status
          );

        }


        return response.text();

      })


      .then(function (text) {

        const html =
          document.createElement('div');


        html.innerHTML =
          text;


        const recommendations =
          html.querySelector(
            'product-recommendations'
          );


        /*
         * Shopify returned no recommendation
         * products yet.
         *
         * Retry instead of permanently giving up.
         */

        if (
          !recommendations ||
          !recommendations.querySelector(
            '.custom-related-products__slide'
          )
        ) {

          if (
            attempt <
            MAX_ATTEMPTS
          ) {

            const delay =
              500 *
              (attempt + 1);


            setTimeout(
              function () {

                loadRecommendations(
                  section,
                  attempt + 1
                );

              },
              delay
            );


            return;

          }


          /*
           * After all attempts,
           * there genuinely may be no
           * recommendations available.
           */

          section.dataset.recommendationsLoaded =
            'true';

          return;

        }


        /*
         * =======================================
         * INSERT PRODUCTS
         * =======================================
         */

        section.innerHTML =
          recommendations.innerHTML;


        section.dataset.recommendationsLoaded =
          'true';


        /*
         * Initialize carousel only after
         * products actually exist.
         */

        initCarousel(section);

      })


      .catch(function (error) {

        console.error(
          'Custom related products:',
          error
        );


        /*
         * Retry network/server failures too.
         */

        if (
          attempt <
          MAX_ATTEMPTS
        ) {

          const delay =
            700 *
            (attempt + 1);


          setTimeout(
            function () {

              loadRecommendations(
                section,
                attempt + 1
              );

            },
            delay
          );


          return;

        }


        section.dataset.recommendationsLoaded =
          'error';

      });

  }


  /*
   * =========================================
   * FIND SECTIONS
   * =========================================
   */

  function initRecommendations() {

    document
      .querySelectorAll(
        'product-recommendations.custom-related-products'
      )
      .forEach(function (section) {

        loadRecommendations(section);

      });

  }


  /*
   * =========================================
   * INITIAL LOAD
   * =========================================
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initRecommendations
    );

  } else {

    initRecommendations();

  }


  /*
   * =========================================
   * SHOPIFY THEME EDITOR
   * =========================================
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector(
          'product-recommendations.custom-related-products'
        );


      if (section) {

        loadRecommendations(section);

      }

    }
  );


})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
